import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import { isDarkMode } from '../../../utils/helpers';
import Panel from '../../../atoms/panels/Panel';
import { RootState } from '../../../store';
import IDVVerification from '../../../modules/IDVVerification';
import SelfieVerification from '../../../modules/SVVerification';
import breakpoints from '../../../theme/material/breakpoints';
import { FONT_FAMILIES } from 'theme/material/constants';
import { getBackgroundTheme, getBorders, getTextColor } from 'style';
import TextLink from 'components/common/TextLink';
import { FULL_URL } from 'config/Master';

const IdVerificationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 10,
  [breakpoints.down(1024)]: {
    flexDirection: 'row',
    width: '100%',
  },
});

const ContactSupportContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginTop: 10,
});

const MyVerificationWrapper = styled('div')({});

const MyVerifications = (): ReactElement => {
  const { liveness, id_verification } = useSelector((state: RootState) => state.profile);
  const account = useSelector((state: RootState) => state.extprofile);

  return (
    <MyVerificationWrapper>
      <Panel
        data-test-id="user-gallery-container"
        withHeader
        title={'My Verifications'}
        className={'profile__my-verifications'}
        isProfile
        cancelButton={<></>}
        panelStyle="borderless"
        customPanelHeaderStyle={{
          marginBottom: 10,
          borderBottom: getBorders().PRIMARY,
        }}
        customTitleStyle={{
          marginTop: 0,
          fontSize: 20,
          fontWeight: 400,
          fontFamily: FONT_FAMILIES.secondary,
          lineHeight: '20px',
          letterSpacing: -0.2,
          ...getTextColor().DARK_4,
        }}
        customStyle={{
          marginTop: 0,
          marginBottom: 15,
          padding: 15,
          [breakpoints.down(768.05)]: {
            marginTop: 15,
            padding: '0 15px 15px',
            backgroundColor: getBackgroundTheme().block3,
            margin: 0,
            boxShadow: 'none',
            borderRadius: 0,
            border: 'none',
          },
        }}
      >
        <IdVerificationContainer>
          {liveness && <SelfieVerification isProfile={true} sideBar={false} />}
          {id_verification.data && (
            <IDVVerification
              isProfile={true}
              account={account}
              sideBar={false}
              customIDVerificationStatusStyle={{
                marginLeft: 0,
                marginRight: 0,
                minWidth: 'unset',
              }}
            />
          )}
        </IdVerificationContainer>
        {(liveness?.status === 'denied' || id_verification.data?.status === 'denied') && (
          <ContactSupportContainer>
            <TextLink
              to={`${FULL_URL}/faq/giving-feedback`}
              target="_blank"
              style={{
                color: isDarkMode() ? '#71B5E4' : '#2B8FD7',
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 400,
                textDecoration: 'underline',
                textUnderlinePosition: 'under',
              }}
            >
              Contact Support
            </TextLink>
          </ContactSupportContainer>
        )}
      </Panel>
    </MyVerificationWrapper>
  );
};

export default React.memo(MyVerifications);
